import React from 'react';
import cx from 'classnames';
import s from './Button.module.scss';
import { ReactNode } from 'react';

interface ButtonProps {
	type: string;
	size?: string;
	btnText?: any;
	onClickHandler?: (e?: any) => void | Promise<void> | undefined;
	isDisabled?: boolean;
	children?: ReactNode;
	className?: string | undefined;
	icon?: any;
}

const Button = (props: ButtonProps) => {
	const {
		type,
		size,
		btnText,
		onClickHandler,
		isDisabled,
		children,
		className = '',
		icon = '',
	} = props;
	const cssClasses = cx(
		s.btn,
		s[`is-${type}`],
		s[`is-${size}`],
		{ [s['is-disabled']]: isDisabled },
		className,
	);
	return (
		<button disabled={isDisabled} className={cssClasses} onClick={onClickHandler}>
			{type === 'iconText' && !!icon && <i className={icon} />}
			{btnText || children}
		</button>
	);
};

export default Button;
